import { createFileRoute } from '@tanstack/react-router';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/risk360')({
  staticData: {
    owner: CodeOwner.FabricAppsPlatform,
  },
  beforeLoad: ({ context, preload }) => {
    context.validateAppPermission('RISK360', preload);
  },
});
